import { useState } from "react";
import { requestPasswordReset } from "../lib/auth";
import { Button } from "../components/ui/Button";

/** Request a password-reset email (PR44). Always shows the same neutral message. */
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await requestPasswordReset(email);
    } finally {
      setSubmitting(false);
      setSubmitted(true);
    }
  };

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm max-w-md mx-auto">
      <h2 className="text-xl font-semibold text-gray-900 mb-1">Reset your password</h2>
      {submitted ? (
        <>
          <p className="text-sm text-gray-600 mt-2">
            If an account exists for that email, you'll receive a reset link shortly.
          </p>
          <div className="mt-4 text-sm">
            <a href="#/login" className="text-accent-700 hover:underline">
              Back to sign in
            </a>
          </div>
        </>
      ) : (
        <>
          <p className="text-sm text-gray-600 mb-5">
            Enter your email and we'll send you a link to choose a new password.
          </p>
          <form onSubmit={submit} className="space-y-3">
            <input
              type="email"
              autoFocus
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@brand.com"
              className="w-full text-sm border border-gray-200 rounded-md px-3 py-2"
            />
            <Button type="submit" variant="primary" disabled={submitting} className="w-full">
              {submitting ? "Sending…" : "Send reset link"}
            </Button>
          </form>
          <div className="mt-4 text-sm text-center">
            <a href="#/login" className="text-accent-700 hover:underline">
              Back to sign in
            </a>
          </div>
        </>
      )}
    </div>
  );
}
